import React from "react";
import "./style.scss";
import Icon from "../icons";
import CardDropdown from "../cardDropdown";
import { cardYearValidation } from "../../helpers/utility"
import { store } from 'react-notifications-component';
import * as Segment from "../../helpers/segment"
import {CardsLoader} from "../loader"
import Popup from "./index"
import DeleteConfirm from "./confirm"
import config from "../../config";
import InputMask from 'react-input-mask';



class ManagePaymentMethod extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
            cardDetails:{expiry:""},
            processing:false,
            // edit:false
            cardToken:"",
            loading:false,
            showIframe:false,
            cardsLoading:false,
            confirmPopup:false,
            deleteItem:{}
        }
        this.listenCardConnect = this.listenCardConnect.bind(this);
    }

    componentDidMount(){
        window.addEventListener("message", this.listenCardConnect);
        if(this.props.user && this.props.user.user){
            if(this.props.businessPaymentType === 'stripe' || this.props.user.user.cardConnectId){
                this.props.getAllCard()
            }
        }
        Segment.track({
            "event":"payment_manage",
            "properties":{
                user:this.props.user.user.id,
                customer_email:this.props.user.user.customer_email,
                customer_phone:this.props.user.user.customer_phone,
                step:"manage_payment_methods"
            }
        })
    }

    componentWillUnmount(){
        window.removeEventListener('message', this.listenCardConnect);
    }

    showError(err){
        if(this.state.toastid){
            store.removeNotification(this.state.toastid)
        }
        let toastid = store.addNotification({
            title: "Error",
            message:err,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 2000,
            }
          });
          this.setState({toastid:toastid})
    }

    listenCardConnect(event) {
        if (event && event.data && event.origin &&  ((event.origin.indexOf("https://fts-uat.cardconnect.com") === 0) || (event.origin.indexOf("https://fts.cardconnect.com") === 0))) {
            const cardConnectEvent = JSON.parse(event.data);
            if (cardConnectEvent.cssLoaded) {
                this.setState({
                    showIframe: true
                });
            }
            if (cardConnectEvent.message && cardConnectEvent.message.length) {
                this.setState({
                    cardToken: cardConnectEvent.message,
                })
            }
            if (cardConnectEvent.validationError && cardConnectEvent.validationError.length) {
                this.setState({
                    cardToken: "",
                })
            }

        }
    }
    async handleSubmit(e) {
        e.preventDefault()
        if (this.state.cardToken && this.state.cardDetails.name && this.state.cardDetails.cvvs && this.state.cardDetails.cvvs.length && this.state.cardDetails.expiry.length && this.state.cardDetails.postal) {
            this.setState({ processing: true, loading: true })
            // YEAR VALIDATION  
            if (this.state.cardDetails.expiry && this.state.cardDetails.expiry.length) {
                if (cardYearValidation(this.state.cardDetails.expiry)) {
                    let payload = { ...this.state.cardDetails, card_token: this.state.cardToken }
                    await this.props.handleAddCard(payload)
                    this.setState({ cardDetails: {}, processing: false, addNewCard: false, cardToken: "", loading: false, showIframe: false })
                }
                else {
                    this.showError("Invalid card expiry")
                    this.setState({ processing: false, loading: false })
                    return
                }
            }
        } else {
            this.showError("Please fill the card details")
            this.setState({ processing: false, loading: false })
        }
    }
    async handleCardEdit(e) {
        e.preventDefault()
        this.setState({ loading: true })
        if (this.state.cardDetails && this.state.cardDetails.token && this.state.cardDetails.acctid && this.state.cardDetails.expiry && this.state.cardDetails.postal) {
            if (this.state.cardDetails.expiry && this.state.cardDetails.expiry.length) {
                if (cardYearValidation(this.state.cardDetails.expiry)) {
                    let payload = { "acctid": this.state.cardDetails.acctid, "expiry": this.state.cardDetails.expiry, "name": this.state.cardDetails.name, postal: this.state.cardDetails.postal }
                    await this.props.handleEditCardconnectCard(payload)
                    this.setState({ cardDetails: {}, processing: false, addNewCard: false, edit: false, loading: false, showIframe: false })
                } else {
                    this.showError("Invalid card expiry")
                    this.setState({ processing: false, loading: false })
                    return
                }
            }
        } else {
            this.showError("Please fill all the card details")
            this.setState({ loading: false })
        }
    }

    handleChange(e){
        let { name, value } = e.target;
        if(name === "expiry" && value.length === 5){
            var mm = value.substring(0, 2);
            var yy = value.substring(3);
            value = mm+yy
            this.setState({ cardDetails :{ ...this.state.cardDetails, [name]: value }});
        }
        if(name === "cvvs"){
            value = value.toString().trim().replace(/[^0-9]+/g, '');
            this.setState({ cardDetails :{ ...this.state.cardDetails, [name]: value }});
        }else{
            this.setState({ cardDetails :{ ...this.state.cardDetails, [name]: value }});
        }
    }
    handleCardDropdown=(item,selected)=>{
         if(selected==="remove"){
             this.setState({addNewCard:false,edit:false,confirmPopup:true,deleteItem:item})
         }
         else if(selected ==="edit"){
             this.setState({addNewCard:true,cardDetails:{...item},edit:true})
             if(item && item.address_zip){
                 this.setState({cardDetails:{...item,postal:item.address_zip}})
             }
         }
     }
    async proceedDelete() {
        if(this.props.businessPaymentType === 'stripe') {
            if (this.state.deleteItem && this.state.deleteItem.paymentMethod) {
                this.setState({loading:true})
                await this.props.removeCard({ "paymentMethod": this.state.deleteItem.paymentMethod})
                this.setState({deleteItem:{},cardDetails:{},confirmPopup:false,loading:false,showIframe:false})
            }
        } else {
            if (this.state.deleteItem && this.state.deleteItem.acctid) {
                this.setState({loading:true})
                await this.props.removeCard({ "acctid": this.state.deleteItem.acctid , "defaultacct": this.state.deleteItem.defaultacct})
                this.setState({deleteItem:{},cardDetails:{},confirmPopup:false,loading:false,showIframe:false})
            }
        }
    }
    cancelDelete(){
        this.setState({deleteItem:{},confirmPopup:false})
    }
    addNewPaymentCard(){
        this.setState({addNewCard:!this.state.addNewCard})
    }
    cancelNewPaymentCard(){
        clearTimeout(this.IframeTimer)
        this.setState({addNewCard:false,edit:false,showIframe:false,cardDetails:{expiry:""}})
    }
    // hideDummy(){
    //      this.IframeTimer = setTimeout(() => {
    //         this.setState({
    //             showIframe: true
    //         });
    //       }, 3000);
    // }
    render(){
        return(
            <div className="manage-payment-method-block">
                <div className="make-payment-content p-20">
                    <div className="align-center">
                        <i className="icon-payment mb-20"><Icon name="payment" /></i>
                        <h2 className="mb-10">Payment Methods</h2>
                        <p className="mb-20">Add, edit or remove your payment methods</p>
                    </div>
                </div>
                {this.props.cardsLoading?<CardsLoader/>:null}
                {!this.props.cardsLoading && (this.props.cardsList && this.props.cardsList.length)?
                <div className="form form-select-card scrollbar pb-20">
                       {this.props.businessPaymentType === 'stripe' && this.props.cardsList && this.props.cardsList.length ? this.props.cardsList.map((item,index)=>(
                        <div key={index} className="item row mb-15 shadow relative">
                            <div className="dropdown dropdown-card-edit absolute top-15 right-15">
                                <CardDropdown item={item} paymentType={this.props.businessPaymentType} handleClick={this.handleCardDropdown.bind(this)}/>
                            </div>
                            <span className="col-4 pl-10">
                            <i className="icon-visa icon-width-78"><Icon name={
                                          item.brand==="amex" ? "americanExpress" :
                                          item.brand                                     } /></i>
                            </span>
                            <span className="col-8">
                                <span className="card-number d-block mb-10 mt-5"><span className="card-elips">....</span> {item.lastFourDigit ? item.lastFourDigit : "*****"}</span>
                                {item.expiryMonth && item.expiryYear ? <span className="card-expiry d-block">{`Expiring on ${item.expiryMonth}/${item.expiryYear}`}</span>:null}
                            </span>
                        </div>
                        ) ) :
                        this.props.businessPaymentType !== 'stripe' && this.props.cardsList && this.props.cardsList.length ? this.props.cardsList.map((item,index)=>(
                            <div key={index} className="item row mb-15 shadow relative">
                            <div className="dropdown dropdown-card-edit absolute top-15 right-15">
                                <CardDropdown item={item} paymentType={this.props.businessPaymentType} handleClick={this.handleCardDropdown.bind(this)}/>
                            </div>
                            <span className="col-4 pl-10">
                            <i className="icon-visa icon-width-78"><Icon name={
                                          item.accttype==="Diners Club"? "diners" :
                                          item.accttype==="VISA" ? "visa" :
                                          item.accttype==="DISC"?"discover":
                                          item.accttype==="AMEX"?"americanExpress":
                                          item.accttype==="MC"?"mastercard":
                                          item.accttype==="Maestro"?"maestro":
                                          item.accttype==="JCB"?"jcb":"card"                                          } /></i>
                            </span>
                            <span className="col-8">
                                <span className="card-number d-block mb-10 mt-5"><span className="card-elips">....</span> {item.token ? item.token.slice(-4):""}</span>
                                {item.expiry ? <span className="card-expiry d-block">{`Expiring on ${item.expiry && item.expiry.slice(0,2)}/${item.expiry && item.expiry.slice(2,4)}`}</span>:null}
                            </span>
                        </div>
                        ) ):null }
                    </div>:null}
                        {this.props.businessPaymentType!=='stripe' && !this.props.cardsLoading && ((this.props.cardsList && this.props.cardsList.length ===0) || this.state.addNewCard || this.state.edit) ? 
                        <>
                         <form onSubmit={ this.state.edit ? this.handleCardEdit.bind(this) :this.handleSubmit.bind(this)} className="form form-select-card">
    
                            <div className="form-group mb-15">
                            <input name="name" onChange={this.handleChange.bind(this)} value={this.state.cardDetails ? (this.state.cardDetails.name ? this.state.cardDetails.name:""):""} className="form-control" placeholder="Cardholder’s Name" />
                        </div>
                          { !this.state.edit ? 
                            <div className="form-group mb-15 relative">
                            <div className={`card-loader ${this.state.showIframe ? "card-loader-hidden":"" } `}>
                                 <img className="loader-img" src="https://dufzo4epsnvlh.cloudfront.net/image/loader-dot.svg" alt="loader"/>
                                 <input name="card" placeholder="Card Number" disabled className="form-control relative" />

                            </div>
                                <iframe id="tokenFrame" name="tokenFrame" title="tokenFrame"
                                     src={config.cardconnectUrl}
                                     frameBorder="0" scrolling="no" height="44" width="100%" />
                            </div>
                           : <div className="form-group mb-15">
                                  <input name="card" disabled className="form-control" value={this.state.cardDetails ? (this.state.cardDetails.token ? `**** **** **** ${this.state.cardDetails.token.slice(-4)}`: this.state.cardDetails.last4 ? `**** **** **** ${this.state.cardDetails.last4}`:""):""} />
                            </div> }
                            <div className="form-group row row-10 mb-20">
                                <div className="col-4">
                                    {/* <input maxLength={5} value={this.state.cardDetails.expiry && this.state.cardDetails.expiry.length ? expiryMask(this.state.cardDetails.expiry):''} name="expiry" onChange={this.handleChange.bind(this)} className="form-control" placeholder="MM/YY" /> */}
                                    <InputMask name="expiry" maskChar={" "} className="form-control"  defaultValue={this.state.cardDetails.expiry} onChange={this.handleChange.bind(this)}  placeholder="MM/YY"  mask="99/99"/>
                                </div>
                                {!this.state.edit ?
                               <React.Fragment>
                                <div className="col-4">
                                    <input maxLength={4} name="cvvs" value={this.state.cardDetails.cvvs} onChange={this.handleChange.bind(this)} className="form-control" placeholder="CVV" />
                                </div>
                                </React.Fragment>
                                : null}
                                 <div className="col-4">
                                    <input name="postal" value={this.state.cardDetails.postal? this.state.cardDetails.postal : ""} onChange={this.handleChange.bind(this)} className="form-control" placeholder="Zip Code" />
                                </div>

                            </div>                        
                        <button disabled={this.props.loading ||(!this.state.showIframe && !this.state.edit)} type="submit" className={`btn btn-primary btn-lg w-100 mb-5 ${(!this.state.showIframe && !this.state.edit) ? "disabled":""} `}>{(this.props.loading && this.state.loading )?"SAVING" :"SAVE PAYMENT METHOD"}
                        {this.state.loading ? <i className="icon-spinner top-4 ml-5 btn-loader"><Icon name="spinner" /> </i>  : null }

                        </button>
                       {(this.props.cardsList && this.props.cardsList.length) || this.state.addNewCard || this.state.edit ?
                        <button type="reset" onClick={this.cancelNewPaymentCard.bind(this)} className="btn btn-border w-100">CANCEL</button> : null}

                        </form>
                        </>
                        :null}
                    
            
                {this.props.businessPaymentType!=='stripe' && !this.props.cardsLoading && ((!this.state.addNewCard && this.props.cardsList && this.props.cardsList.length  ))?
                <div onClick={this.addNewPaymentCard.bind(this)} className="add-newpayment mb-20">
                    + ADD PAYMENT METHOD
                </div>
                : null}
                {this.state.confirmPopup ?
                    <Popup close={this.cancelDelete.bind(this)}>
                        <DeleteConfirm 
                        onOk={this.proceedDelete.bind(this)}
                        onCancel={this.cancelDelete.bind(this)}
                        loading={this.state.loading}
                        />
                    </Popup> : null
                }
                
            </div>
        )
    }
    
}

export default ManagePaymentMethod;
